import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-12 font-titleFont flex flex-col gap-20 md:flex-row"
    >
      <div>
        <div className="flex flex-col gap-4">
          {/* <p className="text-sm text-designColor tracking-[4px]">2023 - 20XX</p> */}
          <h2 className="text-4xl font-bold">Work Experience</h2>
        </div>
        <div className="mt-14 w-full h-full border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Sr. Frontend Consultant"
            subTitle="UST Global Solutions (Nov 25 - Aug 26)"
            result="Hyderabad, India"
            des="Enhanced Broadridge’s microfrontend-based React dashboards through bug fixes and feature enhancements, developed a multilingual Tax Claim interface with PDF preview/download and OpenAI chatbot integration, and improved code quality across three UI services using SonarQube and automated testing."
          />
          <ResumeCard
            title="Sr. Frontend Engineer"
            subTitle="Laucnh Consulting Group (Dec 24 - July 25)"
            result="Hyderabad, India"
            des="Delivered comprehensive frontend test automation for Health Edge by implementing unit and integration tests (Jest, Puppeteer), designing end-to-end workflows (Cypress, Katalon Studio), and monitoring code coverage to ensure high quality, stability, and client satisfaction."
          />
          <ResumeCard
            title="Sr. Frontend Engineer"
            subTitle="MSG Global Solutions (Feb 23 - June 24)"
            result="Bengaluru, India"
            des="Developed and optimized the Employee Search Report Application to improve throughput by 40%, enabling efficient employee profile matching for project requirements. Led UI and backend teams, ensuring high performance, scalability, and timely delivery through effective sprint management."
          />
          <ResumeCard
            title="Sr. Consultant UI"
            subTitle="Optimum Solutions - (Jan 22 - Feb 23)"
            result="Bengaluru, India"
            des="Enhanced the UI and performance of a banking app for Standard Chartered, improving customer engagement by 50% with dynamic visual updates. Transitioned components from JavaScript to TypeScript, optimized performance, and collaborated with the UX team to meet new customer demands."
          />
          <ResumeCard
            title="Sr. Frontend Consultant"
            subTitle="Mindtree ltd - (Aug 21 - Jan 22)"
            result="Bengaluru, India"
            des="Developed and optimized the payment page for MSC Industrial Supply's B2C ecommerce app, improving performance by 60% after migrating from WordPress to ReactJS SPA. Managed state persistence and collaborated with the UI team across multiple application modules for a seamless user experience."
          />
          <ResumeCard
            title="Sr. Frontend Engineer"
            subTitle="Parentof Solutions - (July 20 - June 21)"
            result="Bengaluru, India"
            des="Enhanced a child growth and development app by adding assessments and activities, providing parents with visual reports of their child's development. Collaborated with UI and UX teams to improve app engagement, leading to a 40% increase in customer interaction and positive feedback."
          />
          <ResumeCard
            title="Sr. Consultant UI"
            subTitle="KPIT Technologies - (Nov 17 - Sept 18)"
            result="Bengaluru, India"
            des="Worked with DXC Technologies on Report Management projects, helping Project Managers update deliverable data for upper management across multiple regions. Enhanced application performance to ensure smooth operations and improve efficiency for PMOs.."
          />
          <ResumeCard
            title="Software Engineer"
            subTitle="Lam Research Corp - (Sept 14 - July 17)"
            result="Bengaluru, India"
            des="Contributed to the ECD SABRE® Deposition software by developing components for the Quad station module, improving usability for hardware engineers. Created an Online Project Report PDF generation tool, streamlining documentation for software enhancements and bug fixes.."
          />
        </div>
      </div>
      {/* <div>
        <div className="flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">20XX - 20XX</p>
          <h2 className="text-4xl font-bold">Trainer Experience</h2>
        </div>
        <div className="mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="ML Instructor"
            subTitle="ABC Platform (20XX - 20XX)"
            result="UK"
            des="Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora itaque accusamus corporis dolor debitis natus sapiente, voluptates possimus minima totam!"
          />
          <ResumeCard
            title="Web Developer and Instructor"
            subTitle="ABC King's College (20XX - 20XX)"
            result="CANADA"
            des="Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora itaque accusamus corporis dolor debitis natus sapiente, voluptates possimus minima totam!"
          />
          <ResumeCard
            title="App Developer"
            subTitle="ABC Company (20XX - 20XX)"
            result="India"
            des="Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora itaque accusamus corporis dolor debitis natus sapiente, voluptates possimus minima totam!"
          />
        </div>
      </div> */}
    </motion.div>
  );
};

export default Experience;
